import {
  Box,
  Button,
  Card,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Fade,
  IconButton,
  Typography,
} from '@material-ui/core';
import './index.scss';
import CloseIconModal from 'assets/icons/CloseIconModal';
import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'store';
import { Row } from 'components/Row';
import { Col } from 'components/Col';
import { NewAutoCompleteField } from 'components/NewAutoCompleteField';
import { getFormattedCNPJ } from 'utils/DataFormatUtils';
import { CustomTextField } from 'components/CustomTextField';
import { CustomCheckbox } from 'components/CustomCheckbox';
import {
  changeContratoAssessorEditingValue,
  closeModalDistrato,
  contratoAssessorDescentralizadoCreateDistrato,
  contratoAssessorDescentralizadoEditDistrato,
  loadContratoAssessor,
} from 'store/modules/ContratosFluxoDescentralizado/Assessores/AssessoresActions';
import useValidations from 'pages/Contratos/Fluxos/FluxoDescentralizados/hooks/useValidations';
import moment from 'moment';
import { DateMaskedInput } from 'components/MaskedInputs';
import { Assessor, Empresa } from '../../__types';
import SnackbarUtils from 'utils/SnackbarUtils';
import {
  CONTRATO_ETAPAS_PARAMS_URL,
  CONTRATO_PASSOS,
  CONTRATO_FLUXO_DESCENTRALIZADO,
  ContratoStatus,
  URL_DISTRATO_PARAM,
  VersaoContratoEnum,
  URL_ENTE_DESCENTRALIZADO,
} from 'models/contratos';
import ModalConfirm from 'pages/Contratos/components/ModalConfirm';
import { openModal } from 'store/modules/ModalActions';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { newContratoDescentralizadoEditRoute } from 'library/Routes';
import {
  CreateRouteParams,
  EditRouteParams,
} from 'pages/Contratos/Fluxos/FluxoDescentralizados/__types';
import { loadContratoAdendos } from 'store/modules/AllContratos/AllContratosActions';
import { loadAllEmpresas } from 'store/modules/EmpresasActions';

const ModalDistratoAssessor = () => {
  const [dataError, setDataError] = useState('');
  const params = useParams<CreateRouteParams & EditRouteParams>();
  const languageValues = useSelector(
    (state: RootState) => state.languages.languageValues
  );
  const contratosAssessoresReducer = useSelector(
    (state: RootState) => state.contratosDescentralizadosAssessores
  );
  const empresasReducer = useSelector((state: RootState) => state.empresas);
  const adendosAll = useSelector(
    (state: RootState) => state.allContratos.adendosAll
  );
  const adendoVersaoContratoUm = adendosAll.find(
    (adendo) => adendo.versaoContrato === 1
  );
  const idVersaoContrato = adendoVersaoContratoUm
    ? adendoVersaoContratoUm?.id
    : null;

  const {
    validDadosAssessorDistrato,
    validateDateDistrato,
    desabilitaCampoEspecificoAditivoEDistrato,
  } = useValidations();
  const location = useLocation();
  const history = useHistory();
  const dispatch = useDispatch();

  const fluxoAssessor = location.pathname.includes(URL_ENTE_DESCENTRALIZADO.ASSESSOR);

  const handleDataChange = useCallback(
    (name, value) => {
      dispatch(changeContratoAssessorEditingValue(name, value));
    },
    [dispatch]
  );

  const handleCnpjChange = useCallback(
    (value) => {
      if (value) {
        const currValue = value.value !== '' ? value : '';
        handleDataChange('idEmpresa', currValue.value);
        handleDataChange('cnpjEmpresa', currValue.cnpj);
      } else {
        handleDataChange('idEmpresa', '');
        handleDataChange('cpfAssessores', []);
      }
    },
    [handleDataChange]
  );

  const handleAssessorChange = (value: Assessor[]) => {
    const currValue =
      Array.isArray(value) && value.length > 0
        ? value.map((it) => it.value)
        : [];
    handleDataChange('cpfAssessores', currValue);
  };

  const fechaModalEAtualizaContrato = () => {
    history.push(
      newContratoDescentralizadoEditRoute.getURLWithParams(
        CONTRATO_FLUXO_DESCENTRALIZADO.ASSESSOR,
        CONTRATO_ETAPAS_PARAMS_URL.EDICAO,
        idVersaoContrato,
        CONTRATO_PASSOS.DOCUMENTOS
      )
    );
    dispatch(closeModalDistrato());
    dispatch(
      loadContratoAssessor(idVersaoContrato, VersaoContratoEnum.CONTRATO)
    );
  };

  const verificaSeTemDistrato = () => {
    return adendosAll.some(
      (item) => item.versaoContrato === VersaoContratoEnum.DISTRATO
    );
  };
  const contenDistrato = verificaSeTemDistrato();

  const enviaDistrato = async () => {
    const isEdicaoDistrato = location.pathname.includes(
      URL_DISTRATO_PARAM.EDICAO_DISTRATO
    );
    const isCriacao = location.pathname.includes(
      URL_DISTRATO_PARAM.CADASTRO_DISTRATO
    );
    const isVersaoAditivo = location.pathname.includes(
      URL_DISTRATO_PARAM.VERSAO
    );
    const distratoData = {
      idContrato: idVersaoContrato,
      dataDistrato: contratosAssessoresReducer.contratoEditing.dataDistrato,
      flgAnaliseJuridica:
        contratosAssessoresReducer.contratoEditing.flgAnaliseJuridica,
    };
    const data = { ...distratoData };

    try {
      const formattedDataDistrato = moment(data.dataDistrato, 'DD/MM/YYYY');
      data.dataDistrato = formattedDataDistrato.format('YYYY-MM-DD');

      if (isEdicaoDistrato && isVersaoAditivo) {
        dispatch(
          contratoAssessorDescentralizadoEditDistrato(
            Number(params.idDistrato),
            data,
            () => {
              SnackbarUtils.enqueueSnackbar({
                message: languageValues.successContratoDistratoAtualizar,
                options: {
                  variant: 'success',
                },
              });
              fechaModalEAtualizaContrato();
            },
            (error) => {
              const errorMessage = error.response?.data?.message;
              SnackbarUtils.enqueueSnackbar({
                message: errorMessage,
                options: {
                  variant: 'error',
                },
              });
            }
          )
        );
      } else if (isCriacao && (contenDistrato || !contenDistrato)) {
        dispatch(
          contratoAssessorDescentralizadoCreateDistrato(
            data,
            () => {
              SnackbarUtils.enqueueSnackbar({
                message: languageValues.successContratoDistratoSalvar,
                options: {
                  variant: 'success',
                },
              });
              fechaModalEAtualizaContrato();
              dispatch(loadContratoAdendos(idVersaoContrato));
            },
            (error) => {
              const errorMessage = error.response?.data?.message;
              SnackbarUtils.enqueueSnackbar({
                message: errorMessage,
                options: {
                  variant: 'error',
                },
              });
            }
          )
        );
      }
    } catch (error) {
      SnackbarUtils.enqueueSnackbar({
        message: error,
        options: {
          variant: 'error',
        },
      });
    }
  };

  const abreModalCriacaoDistrato = () => {
    const fechaModal = !desabilitaCampo();
    const status = contratosAssessoresReducer.contratoEditing.flgStatus;

    if (fechaModal) {
      fechaModalEAtualizaContrato();
      return;
    }
    else if (status === ContratoStatus.EM_EDICAO && contenDistrato === true) {
      enviaDistrato();
      fechaModalEAtualizaContrato();
      return;
    }
    dispatch(
      openModal(ModalConfirm, {
        title: languageValues.criacaoDistrato,
        content: languageValues.confirmarCriacaoDistrato,
        confirmLabel: languageValues.confirmar,
        confirmCallback: () => {
          enviaDistrato();
        },
        modalKey: 'modalComplete',
        maxWidth: 'sm',
      })
    );
  };

  const renderizaTituloModal = () => {
    const status = contratosAssessoresReducer.contratoEditing.flgStatus;
    const url = window.location.href;

    if (url.includes(URL_DISTRATO_PARAM.EDICAO_DISTRATO) &&
      (status === ContratoStatus.VIGENTE || status === ContratoStatus.NAO_INICIADO)) {
      return `${languageValues.distrato}`;
    }
    else if (url.includes(URL_DISTRATO_PARAM.EDICAO_DISTRATO)) {
      return `${languageValues.editarDistrato}`;
    }
    return languageValues.criacaoDistrato;
  };

  const desabilitaCampo = () => {
    const isCriacao = location.pathname.includes(
      URL_DISTRATO_PARAM.CADASTRO_DISTRATO
    );
    const { flgStatus, ativo } = contratosAssessoresReducer.contratoEditing;

    if (
      !ativo || (!isCriacao && (flgStatus === ContratoStatus.ENCERRADO ||
        flgStatus === ContratoStatus.VIGENTE || flgStatus === ContratoStatus.NAO_INICIADO))
    ) {
      return false;
    }
    return true;
  };

  useEffect(() => {
    if (fluxoAssessor &&
      (location.pathname.includes(URL_DISTRATO_PARAM.MODAL_EDICAO_DISTRATO) ||
        location.pathname.includes(URL_DISTRATO_PARAM.EDICAO_DISTRATO))) {
      dispatch(loadContratoAssessor(Number(params.idDistrato), VersaoContratoEnum.DISTRATO));
      dispatch(loadAllEmpresas());
    }
  }, [dispatch, fluxoAssessor, location.pathname, params.idDistrato]);

  useEffect(() => {
    if (fluxoAssessor &&
      location.pathname.includes(URL_DISTRATO_PARAM.CADASTRO_DISTRATO)) {
      dispatch(loadContratoAssessor(Number(params.id), VersaoContratoEnum.CONTRATO));
      dispatch(loadAllEmpresas());
    }
  }, [contratosAssessoresReducer.contratoEditing.cnpjEmpresa,
  contratosAssessoresReducer.contratoEditing.idEmpresa, dispatch, fluxoAssessor, location.pathname, params.id])

  return (
    <>
      <Dialog
        open={contratosAssessoresReducer.isModalDistratoOpen}
        aria-labelledby='form-dialog-distrato'
        className='form-dialog-distrato'
        TransitionComponent={Fade}
        transitionDuration={{
          enter: 350,
        }}
        PaperProps={{
          style: {
            boxShadow: 'none',
          },
        }}
      >
        <DialogTitle className='form-dialog-distrato__title-modal'>
          <div className='form-dialog-distrato__titleContainer'>
            <Typography className='form-dialog-distrato__titleModal'>
              {renderizaTituloModal()}
            </Typography>
            <IconButton
              aria-label='close'
              className='form-dialog-distrato__closeButton'
              onClick={() => fechaModalEAtualizaContrato()}
            >
              <CloseIconModal />
            </IconButton>
          </div>
          <div className='form-dialog-distrato__titleLine'></div>
        </DialogTitle>
        <DialogContent>
          <Box className='form-dialog-distrato__box'>
            <Card className='form-dialog-distrato__card'>
              <Box>
                <Row>
                  <Col cols={[12, 12, 12, 12, 12]}>
                    <Typography
                      variant='h5'
                      id='dadosAssessor'
                      className='form-dialog-distrato__tipo-contrato-title'
                    >
                      {languageValues.cadastroContratoDadosAssessor}
                    </Typography>
                  </Col>
                </Row>
                <Row>
                  <Col cols={[12, 12, 6, 6, 6]}>
                    <NewAutoCompleteField
                      id={'empresa'}
                      label={languageValues.cadastroContratoEmpresaRequired}
                      options={empresasReducer.allList.map((item: Empresa) => ({
                        label: `${getFormattedCNPJ(item.cnpjEmpresa)} - ${item.nome
                          }`,
                        value: item.id,
                        cnpj: item.cnpjEmpresa,
                      }))}
                      value={
                        contratosAssessoresReducer.contratoEditing.idEmpresa
                      }
                      onChange={handleCnpjChange}
                      loading={empresasReducer.loadingAllList}
                      loadingMessage={languageValues.loadingEmpresas}
                      disabled={!desabilitaCampoEspecificoAditivoEDistrato()}
                    />
                  </Col>

                  <Col cols={[12, 12, 6, 6, 6]}>
                    <NewAutoCompleteField
                      id={'assessor'}
                      label={languageValues.cadastroContratoAssessorRequired}
                      placeholder={
                        empresasReducer.loadingAllList ||
                          empresasReducer.loadingEmpresaByCnpjAssessoresNecessarios
                          ? languageValues.loadingAssessores
                          : ''
                      }
                      options={(
                        empresasReducer.empresaByCnpjAssessoresNecessarios
                          .assessores || []
                      ).map((item: Assessor) => ({
                        label: item.nome,
                        value: item.cpf,
                      }))}
                      multiple
                      value={
                        contratosAssessoresReducer.contratoEditing.cpfAssessores
                      }
                      onChange={handleAssessorChange}
                      loading={
                        empresasReducer.loadingAllList ||
                        empresasReducer.loadingEmpresaByCnpjAssessoresNecessarios
                      }
                      loadingMessage={languageValues.loadingAssessores}
                      disabled={!desabilitaCampoEspecificoAditivoEDistrato()}
                    />
                  </Col>
                </Row>

                <Row>
                  <Col cols={[12, 12, 12, 12, 12]}>
                    <Typography
                      variant='h5'
                      id='dadosAssessor'
                      className='form-dialog-distrato__tipo-contrato-title'
                    >
                      {languageValues.cadastroContratoDadosContratoDistrato}
                    </Typography>
                  </Col>
                </Row>

                <Row>
                  <Col cols={[12, 12, 6, 6, 6]}>
                    <CustomTextField
                      id={'data-distrato'}
                      label={languageValues.cadastroContratoDataDistrato}
                      name='dataDistrato'
                      value={
                        contratosAssessoresReducer.contratoEditing.dataDistrato
                      }
                      onChange={(
                        event: React.ChangeEvent<HTMLInputElement>
                      ) => {
                        const value = event.target.value.trim();
                        const validation = validateDateDistrato(value);
                        setDataError(validation.error);
                        handleDataChange('dataDistrato', value);
                      }}
                      helperText={dataError ? dataError : ''}
                      error={dataError !== ''}
                      InputProps={{ inputComponent: DateMaskedInput }}
                      disabled={!desabilitaCampo()}
                    />
                  </Col>
                </Row>

                <Row>
                  <Col cols={[12, 12, 6, 6, 6]}>
                    <CustomCheckbox
                      id={'analise-juridica'}
                      className={'form-dialog-distrato__analise-juridica'}
                      label={languageValues.flgAnaliseJuridicaAceite}
                      name='flgAnaliseJuridica'
                      onChange={(
                        event: React.ChangeEvent<HTMLInputElement>
                      ) => {
                        handleDataChange(
                          'flgAnaliseJuridica',
                          event.target.checked
                        );
                      }}
                      checked={
                        contratosAssessoresReducer.contratoEditing
                          .flgAnaliseJuridica
                      }
                      disabled={!desabilitaCampo()}
                    />
                  </Col>
                </Row>
              </Box>
            </Card>
          </Box>
        </DialogContent>
        <DialogActions className='form-dialog-distrato__dialog-actions'>
          <Button
            className='form-dialog-distrato__btnClose'
            onClick={() => fechaModalEAtualizaContrato()}
          >
            {languageValues.cancelButton}
          </Button>
          <Button
            className='form-dialog-distrato__btnSave'
            onClick={() => abreModalCriacaoDistrato()}
            disabled={!validDadosAssessorDistrato()}
          >
            {languageValues.concluir}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default React.memo(ModalDistratoAssessor)
